<template>
  <div class="home">
    <swiper :options="swiperOption">
      <swiper-slide>
        <img
          src="@/assets/images/slide_item_1.png"
          class="img-fluid"
          style="cursor: pointer"
          @click="publish"
          alt=""
        />
      </swiper-slide>
      <swiper-slide>
        <router-link to="/vendor"
          ><img src="@/assets/images/slide_item_2.png" class="img-fluid" alt=""
        /></router-link>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="container content">
      <div class="project">
        <h2 class="title">推荐项目<span>/Recommended item</span></h2>
        <div class="middle">
          <div class="type-block">
            <button
              class="m-button px-2 py-1 px-md-4 py-md-2"
              :class="{ active: currentType === 0 }"
              @click="selectType(0)"
            >
              热门项目
            </button>
            <button
              class="m-button px-2 py-1 px-md-4 py-md-2"
              :class="{ active: currentType === 1 }"
              @click="selectType(1)"
            >
              最新项目
            </button>
          </div>
          <router-link to="/market" class="more">查看更多></router-link>
        </div>
        <project-list :list="projectList"></project-list>
      </div>
      <div class="vendor">
        <div class="title-block">
          <h2 class="title">
            推荐供应商
            <span>/Recommended supplier</span>
          </h2>
          <router-link to="/market" class="more">查看更多></router-link>
        </div>
        <vendor-list :list="vendorList"></vendor-list>
      </div>
    </div>
    <publish-modal ref="publishModal"></publish-modal>
  </div>
</template>

<script>
import PublishModal from '@/components/PublishModal';
import ProjectList from '@/components/ProjectList';
import VendorList from '@/components/VendorList';
import ApiService from '@/common/api.service';
import { mapMutations } from 'vuex';
import qs from 'qs';
import { shuffle } from '@/common/utils';
export default {
  name: 'home',
  components: { ProjectList, VendorList, PublishModal },
  data() {
    return {
      currentType: 0,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        }
      },
      projectList: [],
      vendorList: []
      // projectList: Array(6).fill({
      //   name: 'APP二次开发，增加扫码功能APP二次开发',
      //   type: '类别：软件设计 > APP开发',
      //   price: '预算：￥10,000',
      //   date: '2019/08/20'
      // })
    };
  },
  created() {
    this.setAuth(false);
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getProject();
      this.getVendor();
    },
    getProject() {
      ApiService.post('/orderInterface/serachOrderMsgNew.htm').then(data => {
        this.projectList = data.list;
        console.log(this.count);
        console.log(this.projectList);
      });
    },
    getVendor() {
      ApiService.post(
        '/supplierInterface/serachSupplier.htm',
        qs.stringify({
          pageNo: 1,
          pageSize: 6
        })
      ).then(data => {
        this.count = data.count;
        this.vendorList = data.list;
        console.log(this.count);
        console.log(this.vendorList);
      });
    },
    publish() {
      this.$refs.publishModal.show();
    },
    selectType(type) {
      this.currentType = type;
      this.projectList = shuffle(this.projectList);
    },
    ...mapMutations(['setAuth'])
  }
};
</script>
<style lang="scss" scoped>
.home {
  .content {
    .project {
      margin-top: 3.63rem;
      .title {
        text-align: left;
        font-size: 1.75rem;
        color: #333;
        margin-bottom: 2.31rem;
        span {
          font-size: 1.5rem;
          color: #999999;
        }
      }
      .middle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 3rem;
        .type-block {
          display: flex;
          .m-button {
            display: inline-block;
            background-color: white;
            // width: 9.38rem;
            // height: 2.38rem;
            border: solid 0.06rem #9f1711;
            color: #666666;
            outline: none;
            font-size: 1.25rem;
            padding: 0;
            &.active {
              color: white;
              background-color: $acentColor;
            }
          }
        }
        .more {
          font-size: 1.25rem;
          color: #999999;
          text-decoration: none;
          white-space: nowrap;
        }
      }
    }
    .vendor {
      .title-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          text-align: left;
          font-size: 1.75rem;
          color: #333;
          margin-bottom: 2.31rem;
          span {
            font-size: 1.5rem;
            color: #999999;
          }
        }
        .more {
          font-size: 1.25rem;
          color: #999999;
          text-decoration: none;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
